module.exports = (window.__publicpath__ || __webpack_public_path__) + "static/media/vector.186eb0a1.svg";